import * as React from "react";

import { Desktop, Mobile, Tablet } from "containers/Responsive/Div3";
import {
  appendToClassName,
  arrayJoinWithGetter,
  valueIsDefined,
} from "lib/helpers";

interface Props {
  children: React.ReactNode;
  className?: string;
  id?: string;
  usesSeparator?: boolean;
  inverted?: boolean;
}

function getHorizontalSeparator(i: number) {
  return (
    <>
      <div className="horizontal-separator-container" key={`separator-${i}`}>
        <div
          className="horizontal-separator separator"
          key={`separator-line-${i}`}
        />
      </div>
    </>
  );
}

function getVerticalSeparator(i: number) {
  return (
    <>
      <div className="vertical-separator-container" key={`separator-${i}`}>
        <div
          className="vertical-separator separator"
          key={`separator-line-${i}`}
        />
      </div>
    </>
  );
}

export function Listing(props: Props) {
  /**
   * Layout: horizontal (left to right) on desktop, vertical (top to bottom) on mobile.
   *
   * By default, left-most element on desktop becomes top-most element on mobile.
   * If parameter 'invert' is given, right-most element on desktop becomes top-most on mobile.
   */
  const { children, className, id, usesSeparator, inverted } = props;

  const childrenArray = React.Children.toArray(children);
  const filteredChildren = childrenArray.filter(
    x =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ((x as any).props.dependencies !== undefined &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (x as any).props.dependencies.every((x: any) => valueIsDefined(x))) ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x as any).props.dependencies === undefined,
  );

  return (
    <>
      <Desktop>
        <div
          id={id || ""}
          className={appendToClassName("desktop hd-vm-layout", className)}
        >
          {(usesSeparator
            ? arrayJoinWithGetter(filteredChildren, getVerticalSeparator)
            : filteredChildren
          ).map((z, i) => (
            <React.Fragment key={`item-${i}`}> {z} </React.Fragment>
          ))}
        </div>
      </Desktop>
      <Tablet>
        <div
          id={id || ""}
          className={appendToClassName("desktop hd-vm-layout", className)}
        >
          {(usesSeparator
            ? arrayJoinWithGetter(childrenArray, getVerticalSeparator)
            : childrenArray
          ).map((z, i) => (
            <React.Fragment key={`item-${i}`}> {z} </React.Fragment>
          ))}
        </div>
      </Tablet>
      <Mobile>
        <div
          id={id || ""}
          className={appendToClassName(
            inverted ? "mobile hd-vm-layout inverted" : "mobile hd-vm-layout",
            className,
          )}
        >
          {(usesSeparator
            ? arrayJoinWithGetter(filteredChildren, getHorizontalSeparator)
            : filteredChildren
          ).map((z, i) => (
            <React.Fragment key={`item-${i}`}> {z} </React.Fragment>
          ))}
        </div>
      </Mobile>
    </>
  );
}
